export const getPortfolioOverviewKpiApi = () =>
  `/analytics/module/fleet-portfolio-overview`;

export const getPinnedGraphsApi = () => `/analytics/module/graphs/pinned`;
